<template>
  <div class="modal show" tabindex="-1" role="dialog" @click.self="backClick">
    <div :class="'modal-dialog ' + sizeClass" role="document">
      <div class="modal-content">
        <div class="modal-header" v-if="title">
          <h5 class="modal-title">{{title}}</h5>
          <button type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot />
        </div>
        <div class="modal-footer" v-if="$slots.actions">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    sizeClass: {
      type: String,
      required: false,
      default: 'modal-xl'
    },
    autoClose: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    backClick(){
      if(this.autoClose) {
        this.$emit('close');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal{
  display: flex;
  height: 100vh;
  position: fixed;
  width: 100vw;
  justify-content: center;
  background-color: rgba(0,0,0,.25);
    &-content{
        border-radius: 12px;
        border: none;
        box-shadow: none;
        background-color: #fff;
    }
  .modal-dialog{

    margin: 40px auto;
    width: 100%;
    // max-width: 80%;

  }
}
</style>